import { ALWAYS_SUPER_ADMIN_ONLY_KEYS } from './catalog';

/**
 * Decide se um item de menu (identificado por `key`, que é o campo
 * `name` do item na sidebar) deve ser visível para o `role` atual, dada
 * a configuração salva (`config`, no formato { key: ['administrator'] }).
 * Ausência de configuração para uma chave = visível para todos (padrão
 * retrocompatível: nada muda até o admin configurar algo).
 *
 * `isSuperAdmin` é independente do `role` de conta — Super Admin é um
 * tipo de usuário à parte no Chatwoot (ver useSuperAdmin.js).
 */
export function isMenuKeyVisible(key, role, config, isSuperAdmin) {
  if (ALWAYS_SUPER_ADMIN_ONLY_KEYS.includes(key)) {
    return !!isSuperAdmin;
  }

  // Distingue "chave nunca salva" (visível pra todos, padrão) de "chave
  // salva com array vazio" (admin desmarcou os dois papéis de propósito
  // = ocultar de todo mundo). Antes, `[]` era tratado igual a "nunca
  // configurado" e acabava sendo ignorado, mostrando o item mesmo
  // depois do admin escondê-lo de todos.
  if (!config || !(key in config)) return true;

  const allowedRoles = config[key];
  return Array.isArray(allowedRoles) && allowedRoles.includes(role);
}

/**
 * Filtra recursivamente uma lista de itens de menu (com possíveis
 * `children`) removendo os que não são visíveis para o `role` atual.
 */
export function filterMenuByVisibility(items, role, config, isSuperAdmin) {
  return items
    .filter(item => isMenuKeyVisible(item.name, role, config, isSuperAdmin))
    .map(item =>
      item.children
        ? {
            ...item,
            children: filterMenuByVisibility(
              item.children,
              role,
              config,
              isSuperAdmin
            ),
          }
        : item
    );
}
